import React from 'react';

import { ModalProps } from 'types/Modal';
import ShareItemsTable from 'views/Datasets/components/RequestAccess/ShareItemsTable';
import { useAlert } from 'components/message/AlertContext';
import { NDialog } from '@innersource-nn/novoui-react';

export interface EditItemsModalProps extends ModalProps {
    shareUri: string;
    resourceUri: string;
    onSubmit: () => void;
}

export default function EditItemsModal({
    visible,
    onClose,
    shareUri,
    resourceUri,
    onSubmit,
}: EditItemsModalProps) {
    const { openAlert } = useAlert();

    const handleClose = (creationError: string) => {
        if (creationError !== '') {
            openAlert({
                message: 'Error updating the request: ' + creationError,
                severity: 'alert',
            });
        } else {
            openAlert({
                message: 'Share request properly updated',
                severity: 'success',
            });
        }
        onSubmit();
        if (onClose) onClose();
    };
    return (
        visible &&
        onClose && (
            <NDialog
                isVisible={visible}
                closeDialog={onClose}
                backgroundClose
                headline="Edit share request"
                size="medium"
                showDividers={false}
            >
                <div>
                    <ShareItemsTable
                        shareUri={shareUri}
                        onClose={onClose}
                        resourceUri={resourceUri}
                        buttonLabel="Update share request"
                        handleNext={(data) => {
                            handleClose(data?.creationError ?? '');
                        }}
                    />
                </div>
            </NDialog>
        )
    );
}
